var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs:business"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.8747 7.29167H15.6247C15.3484 7.29167 15.0835 7.40141 14.8881 7.59676C14.6928 7.79211 14.583 8.05707 14.583 8.33333V11.4583H12.4997V4.16667C12.4997 3.8904 12.3899 3.62545 12.1946 3.4301C11.9992 3.23475 11.7343 3.125 11.458 3.125H3.12467C2.84841 3.125 2.58346 3.23475 2.3881 3.4301C2.19275 3.62545 2.08301 3.8904 2.08301 4.16667V20.8333C2.08301 21.1096 2.19275 21.3746 2.3881 21.5699C2.58346 21.7653 2.84841 21.875 3.12467 21.875H21.8747C22.1509 21.875 22.4159 21.7653 22.6112 21.5699C22.8066 21.3746 22.9163 21.1096 22.9163 20.8333V8.33333C22.9163 8.05707 22.8066 7.79211 22.6112 7.59676C22.4159 7.40141 22.1509 7.29167 21.8747 7.29167ZM8.33301 6.25H10.4163V8.33333H8.33301V6.25ZM6.24967 16.6667H4.16634V14.5833H6.24967V16.6667ZM6.24967 12.5H4.16634V10.4167H6.24967V12.5ZM6.24967 8.33333H4.16634V6.25H6.24967V8.33333ZM10.4163 16.6667H8.33301V14.5833H10.4163V16.6667ZM10.4163 12.5H8.33301V10.4167H10.4163V12.5ZM19.7913 16.6667H17.708V14.5833H19.7913V16.6667ZM19.7913 12.5H17.708V10.4167H19.7913V12.5Z",
    fill: "#545454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.735acae02bfc4c3fdd8364e9054c5f00.svg";
export { ForwardRef as ReactComponent };